export default "__VITE_ASSET__CugfGXHP__"